import { Autocomplete, FormControl, FormGroup, FormLabel, Switch, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useController } from "react-hook-form";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { BackButton } from "./Button";

export const FormTitle = ({ title }) => (
  <MDBox pb={1}>
    <MDTypography color="info" variant="h3">
      {title}
    </MDTypography>
  </MDBox>
);

export const ButtonField = ({ field, onClick }) => (
  <MDButton color="info" variant="gradient" onClick={onClick}>
    {field.label}
  </MDButton>
);

export const TitleField = ({ label, button = null }) => (
  <MDBox display="flex" justifyContent="space-between">
    <MDTypography pt={1} pb={2} color="info" variant="h5">
      {label}
    </MDTypography>
    {button}
  </MDBox>
);

export const TitleButton = ({ label, onClick }) => (
  <MDButton
    sx={{ height: "20px", padding: "10px" }}
    color="info"
    variant="gradient"
    onClick={onClick}
  >
    {label}
  </MDButton>
);

const StyledText = styled(TextField)({
  // "& .MuiInputLabel-root": {
  //   color: "red !important",
  // },
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },

  // "& .Mui-disabled input":{
  //   //color: "black",
  //   WebkitTextFillColor:"black"
  // }
  // "& label":{
  //   color:"red"
  // },
  // "& .MuiOutlinedInput-root":{
  //   "& .Mui-focused":{
  //     color:"red"
  //   },
  //   "& .Mui-disabled":{
  //     color:"red"
  //   },
  // },

  // "& .Mui-focused":{
  //   color:"red"
  // }
});

const RequiredText = styled(TextField)({
  "& .MuiInputLabel-root": {
    color: "red !important",
  },
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

export const ReadonlyText = ({ field, ...prop }) => (
  <StyledText
    type="text"
    name={field.name}
    label={field.label}
    value={field.value ?? ""}
    InputProps={{ disabled: true }}
    fullWidth
    {...prop}
  />
);

export const Text = ({ field: field2 }) => {
  const {
    type,
    label,
    //value,
    required,
    tabIndex,
    disabled,
    maxLength,
    name,
    //register,
    errors,
    control,
    onChange,
    onBlur,
  } = field2;
  const { field } = useController({ name, control });
  const getErrorByProperty = (errors, property) => {
    const pathParts = property.split(".");
    let current = errors;

    for (const part of pathParts) {
      current = current?.[part];
      if (!current) return undefined;
    }

    return current;
  };
  const textFieldProps = {
    label,
    type,
    //value,
    //...register(name),
    ...(required && { required }),
    ...(disabled && { disabled }),
    ...(maxLength && { inputProps: { maxLength } }),
    ...(tabIndex && { inputProps: { tabIndex } }),
    ...(onChange && { onChange }),
    ...(onBlur && { onBlur }),
    ...(getErrorByProperty(errors, name) && {
      error: true,
      helperText: getErrorByProperty(errors, name).message,
    }),
    //...(value.length>0&&{InputLabelProps:{shrink:true}})
  };

  const fieldChange = ({ target }) => {
    let value = target.value;
    if (value.trim().length === 0) {
      if (type === "text" || type === "password") {
        field.onChange(null);
      } else {
        field.onChange(0);
      }
      return;
    }
    if (type === "text" || type === "password") {
      field.onChange(value);
    } else {
      value = Number(value);
      field.onChange(value);
    }
  };
  return required ? (
    <RequiredText
      sx={{ mb: 1.5 }}
      onChange={onChange || fieldChange}
      value={field.value === null ? "" : field.value}
      {...textFieldProps}
      fullWidth
    />
  ) : (
    <StyledText
      sx={{ mb: 1.5 }}
      onChange={onChange || fieldChange}
      value={field.value === null ? "" : field.value}
      {...textFieldProps}
      fullWidth
    />
  );
};

export const Texts = ({ field, onChange }) => {
  return (
    <StyledText
      {...(field.ref && { inputRef: field.ref ?? "" })}
      {...(field.maxLength && { inputProps: { maxLength: field.maxLength } })}
      type="text"
      name={field.name}
      label={field.label}
      value={field.value === null ? "" : field.value}
      fullWidth
      onChange={onChange}
    />
  );
};

export const ReadOnlyTextField = ({ field: field2 }) => {
  const { type, label, name, control } = field2;
  const { field } = useController({ name, control });
  const textFieldProps = {
    label,
    type,
    disabled: true,
  };

  const value =
    field.value !== null ? (typeof field.value === "object" ? field.value.label : field.value) : "";
  return <StyledText sx={{ mb: 1.5 }} value={value} {...textFieldProps} fullWidth />;
};

export const SwitchField = ({ field: field2 }) => {
  const { label, name, value, tabIndex, readOnly, control } = field2;
  const { field } = useController({ name, control });
  const switchProps = {
    checked: field.value,
    onChange: readOnly ? () => {} : field.onChange,
    ...(tabIndex && { inputProps: { tabIndex } }),
  };
  return (
    <FormControl
      sx={{
        margin: "-8px 0 12px 0",
        padding: "8px",
        height: "50px",
        borderRadius: ".375rem",
        border: "1px solid #d6d2da",
      }}
      component="fieldset"
      fullWidth
    >
      <FormLabel
        sx={{ "&.Mui-focused": { color: "#1A73E8" }, padding: "0 4px", fontSize: "12px" }}
        component="legend"
      >
        {label}
      </FormLabel>
      <FormGroup sx={{ marginTop: "-12px" }}>
        <Switch {...switchProps} />
      </FormGroup>
    </FormControl>
  );
};

export const SwitchField2 = ({ field: field2, pickingRules, onChange, shouldDisable }) => {
  const { label, name, value, tabIndex, control } = field2;
  const { field } = useController({ name, control });

  const handleChange = (e) => {
    if (!shouldDisable) {
      field.onChange(e); // React Hook Form's onChange
      onChange(e); // Parent component's onChange
    }
  };

  const switchProps = {
    checked: field.value,
    onChange: handleChange,
    ...(tabIndex && { inputProps: { tabIndex } }),
  };

  return (
    <FormControl
      sx={{
        margin: "-8px 0 12px 0",
        padding: "8px",
        height: "50px",
        borderRadius: ".375rem",
        border: "1px solid #d6d2da",
      }}
      component="fieldset"
      fullWidth
    >
      <FormLabel
        sx={{ "&.Mui-focused": { color: "#1A73E8" }, padding: "0 4px", fontSize: "12px" }}
        component="legend"
      >
        {label}
      </FormLabel>
      <FormGroup sx={{ marginTop: "-12px" }}>
        <Switch {...switchProps} />
      </FormGroup>
    </FormControl>
  );
};

export const SelectField = ({ field: field2, options, onChange }) => {
  const { name, value, label, required, disabled, errors, control, multiple, style = {} } = field2;
  const { field } = useController({ name, control });
  const autocompleteProps = {
    options,
    getOptionLabel: (option) => {
      return option.label ?? option;
    },
    isOptionEqualToValue: (option, value) => {
      if (option.value) {
        return option.label === value || option.value === value;
      } else {
        return option === value;
      }
    },
    //name,
    //value: value === null ? value : value.label ? value.label : value,
    value: field.value === null ? field.value : field.value.label ? field.value.label : field.value,
    disableClearable: required ? true : false,
    ...(multiple && { multiple }),
    onChange: onChange
      ? onChange
      : (e, v) => {
          field.onChange(v);
          // if(v===null){
          //   field.onChange(v);
          //   return
          // }
          // if(v.value){
          //   field.onChange(v.value)
          // }else{
          //   field.onChange(v)
          // }
        },
    sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
    renderInput: (params) => {
      if (required) {
        return (
          <RequiredText
            {...params}
            sx={{ mb: 1.5 }}
            label={label}
            name={name}
            //value={field.value||""}
            {...(required && { required })}
            //{...(disabled && { disabled })}
            {...(errors[name] && { error: true, helperText: errors[name].message })}
          />
        );
      } else {
        return (
          <StyledText
            {...params}
            sx={{ mb: 1.5, ...style }}
            label={label}
            name={name}
            //value={field.value||""}
            {...(required && { required })}
            //{...(disabled && { disabled })}
            {...(errors[name] && { error: true, helperText: errors[name].message })}
          />
        );
      }
    },
  };
  return <Autocomplete {...autocompleteProps} />;
};

export const SelectFields = ({ field, options, onChange }) => {
  const { name, value, label, required, disabled, errors, multiple } = field;
  const autocompleteProps = {
    options,
    getOptionLabel: (option) => {
      return option.label ?? option;
    },
    isOptionEqualToValue: (option, value) => {
      if (option.value) {
        return option.label === value || option.value === value;
      } else {
        return option === value;
      }
    },
    value,
    ...(multiple && { multiple, disableCloseOnSelect: true }),
    disableClearable: required ? true : false,
    disabled,
    //name,
    //value: value === null ? value : value.label ? value.label : value,
    //value: field.value,
    onChange,
    sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
    renderInput: (params) => {
      if (required) {
        return (
          <RequiredText
            {...params}
            sx={{ mb: 1.5 }}
            label={label}
            name={name}
            {...(required && { required })}
            {...(errors[name] && { error: true, helperText: errors[name].message })}
          />
        );
      } else {
        return (
          <StyledText
            {...params}
            sx={{ mb: 1.5 }}
            label={label}
            name={name}
            {...(required && { required })}
            {...(errors[name] && { error: true, helperText: errors[name].message })}
          />
        );
      }
    },
  };
  return <Autocomplete {...autocompleteProps} />;
};

export const SubmitButton = ({ label, disabled, url }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="info" disabled={disabled}>
      {label}
    </MDButton>
    <BackButton label="Back" url={url} />
  </MDBox>
);

export const SaveButton = ({ label, disabled, url }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="info" disabled={disabled}>
      {label}
    </MDButton>
    <BackButton url={url} />
  </MDBox>
);

export const InboundSubmitButton = ({ label, disabled, onClick }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="info" onClick={onClick} disabled={disabled}>
      {label}
    </MDButton>
  </MDBox>
);
export const InboundSaveButton = ({ label = "Save", disabled, onClick, url, state = null }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="info" onClick={onClick} disabled={disabled}>
      {label}
    </MDButton>
    <BackButton url={url} {...(state && { state })} />
  </MDBox>
);

export const InboundDetailAddButton = ({ label = "Add", disabled = false }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="info" disabled={disabled}>
      {label}
    </MDButton>
  </MDBox>
);

export const InboundDetailEditButton = ({ label = "Update", disabled, onClick }) => (
  <MDBox mt={2} width="100%" display="flex" justifyContent="center">
    <MDButton type="submit" variant="gradient" color="success" disabled={disabled}>
      {label}
    </MDButton>
    <MDButton
      sx={{ marginLeft: "1.5rem" }}
      type="button"
      variant="gradient"
      color="info"
      onClick={onClick}
    >
      Back
    </MDButton>
  </MDBox>
);

export const Fieldset = ({ children, label, sx }) => (
  <FormControl
    sx={{
      padding: "0 15px 10px 15px",
      marginBottom: "12px",
      borderRadius: ".375rem",
      border: "2px solid #d6d9f6",
      ...(sx && { ...sx }),
    }}
    component="fieldset"
    fullWidth
  >
    <FormLabel
      sx={{ padding: "0 10px 8px 8px", color: "#1A73E7", fontWeight: "bold" }}
      component="legend"
    >
      {label}
    </FormLabel>
    {children}
  </FormControl>
);

const StyledDatePicker = styled(DatePicker)({
  // "& .MuiInputLabel-root": {
  //   color: "red !important",
  // },
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

const RequiredDatePicker = styled(DatePicker)({
  "& .MuiInputLabel-root": {
    color: "red !important",
  },
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

const StyledDateTimePicker = styled(DateTimePicker)({
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

const RequiredDateTimePicker = styled(DateTimePicker)({
  "& .MuiInputLabel-root": {
    color: "red !important",
  },
  "& .Mui-disabled": {
    backgroundColor: "#f0f2f8",
    input: {
      WebkitTextFillColor: "#455058",
    },
  },
});

export const DatePickerField = ({ field: field2 }) => {
  const { label, name, required, disabled, errors, control } = field2;

  const { field } = useController({ name, control });
  const inputProps = {
    label,
    format: "DD / MM / YYYY",
    value: field.value === null ? null : dayjs(field.value),
    onChange: (v) => {
      //alert(v)
      //alert(field.value)
      if (v) {
        field.onChange(dayjs(v).format("YYYY-MM-DD"));
      } else {
        field.onChange(null);
      }
    },
    slotProps: {
      textField: {
        sx: { mb: 1.5 },
        fullWidth: true,
        //...(required&&{required})
        ...(required && { required }),
        ...(errors[name] && { error: true, helperText: errors[name].message }),
      },
      actionBar: {
        actions: ["clear"],
      },
    },
    ...(disabled && { disabled }),
  };
  return required ? (
    <RequiredDatePicker {...inputProps} />
  ) : (
    <StyledDatePicker
      // sx={{
      //   color:"red"
      // }}
      // slotProps={{textField:{
      //   sx:{
      //     color:"red"
      //   }
      // }}}
      {...inputProps}
    />
  );
};

export const DateTimePickerField = ({ field: field2 }) => {
  const { label, name, required, disabled, errors, control } = field2;
  if(name==="arrivalDate") console.log(required)

  const { field } = useController({ name, control });
  const inputProps = {
    label,
    format: "DD / MM / YYYY  HH : mm",
    value: field.value === null ? null : dayjs(field.value),
    onChange: (v) => {
      if (v) {
        field.onChange(dayjs(v).format("YYYY-MM-DD HH:mm:ss"));
      } else {
        field.onChange(null);
      }
    },
    slotProps: {
      textField: {
        sx: { mb: 1.5 },
        fullWidth: true,
        //...(required&&{required})
        ...(required && { required }),
        ...(errors[name] && { error: true, helperText: errors[name].message }),
      },
      actionBar: {
        actions: ["clear"],
      },
      digitalClockSectionItem: {
        sx: { minWidth: "0" },
      },
    },
    ampm:false,
    ...(disabled && { disabled }),
  };
  return required ? (
    <RequiredDateTimePicker {...inputProps} />
  ) : (
    <StyledDateTimePicker {...inputProps} />
  );
};

export const LineField = () => (
  <MDBox sx={{ width: "100%", margin: "7px 0 19px 0", border: "1px solid #d6d9f6" }}></MDBox>
);
